import { Col, Text } from 'components';
import { getYtId } from 'lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactPlayer from 'react-player';
import { RemoveButton } from 'screens/Admin/components';
import styled from 'styled-components';

const Thumbnail = styled.div`
  height: 400px;
  background-image: url(${(props) => props.image});
  background-repeat: no-repeat;
  display: flex;
  background-position: center;
  background-size: cover;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const Youtube = ({ youtubeId, setYoutubeId, err, isEditing }) => {
  const [thumbnail, setThumbnail] = useState(null),
    [error, setError] = useState(''),
    [value, setValue] = useState(''),
    { t } = useTranslation();

  useEffect(() => {
    if (!value) return setError('');

    const ytId = getYtId(value);

    if (!ytId) {
      setYoutubeId('');
      return setError(t('add.correctYoutubeLink'));
    }

    setYoutubeId(ytId);
    setThumbnail(`https://img.youtube.com/vi/${ytId}/0.jpg`);
    setError('');
  }, [value]);

  useEffect(() => {
    if (!err) return;

    setError(err.err);
  }, [err]);

  function removeLink() {
    setYoutubeId(null);
    setValue('');
  }

  return (
    <Col wid="100%" marg="24px 0 0">
      <Text marg="0 16px 4px" b2 med>
        Youtube link
      </Text>

      <Col noFlex pos="relative">
        <RemoveButton onClick={removeLink} />

        <ReactPlayer
          url={`https://www.youtube.com/watch?v=${youtubeId}`}
          style={{ maxWidth: 552 }}
          controls
        />
      </Col>
    </Col>
  );
};

export default Youtube;

// <Thumbnail image={`https://img.youtube.com/vi/${youtubeId}/0.jpg`}>
//   <CloseContainer onClick={removeLink}>
//     <Col centerAll ht='100%'>
//       <Icon type='close' dimensions={12} col='#fff'/>
//     </Col>
//   </CloseContainer>
//
//   <Col
//     wid='48px'
//     ht='48px'
//     noFlex
//     bg='rgba(210, 216, 223, 0.7)'
//     hasRadius='48px'
//     centerAll
//     style={{ alignSelf: 'center' }}
//   >
//     <Icon type='playOutline' dimensions={14}/>
//   </Col>
// </Thumbnail>
